// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__PtI3f","errorIcon":"Error_errorIcon__Seqj0","errorMessage":"Error_errorMessage__lrMRz","errorStack":"Error_errorStack__S9fBc"};